import React, { useEffect, useRef, useState } from 'react';
import ProvidersPopup from './popups/providerspopup';
import StatusPopup from './popups/statuspopup';
import { Backdrop, Chip, CircularProgress, Stack } from '@mui/material';
import { convertToVaTime } from '../dateutils/date';
import FilterPopup from './popups/filterpopup';
import api from '../api/api';
import RoomPopup from './popups/roompopup';
import StatusFilterPopup from './popups/filterbystatus';
import ProviderFilterPopup from './popups/filterbyprovider';
import Payments from './popups/Payments';
import dollarS from '../assets/Signin/Dollar.svg'
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DropdownMenu from './popups/Menu';
import labsIcon from '../../src/assets/Signin/LabsIcon.svg'
import { useSelector } from 'react-redux';
import { printEncounterForPatient, fmtName, fmtTime } from '../printnotes/encounterData';
const SigninTable = ({data,loading,setData,selectedDate,isChecked,fetchdata,providersdata,setProvidersData,onStatusSelect, onProviderSelect, statusdata}) => {
 
const [isProvidersPopup,setIsprovidersPopup]=useState(false)
const [isStatusPopup,setIsStatusPopup]=useState(false)
const [isFilterPopup,SetIsFilterPopup]=useState(false)
const [isstatusFilterpopup,SetIsStatusFilterPopup]=useState(false);
const [isProviderfilter,setIsProviderFilter]=useState(false)
const[roomPopUp,setRoomPopUp]=useState(false)
const [paymentModal,setpaymentModal]=useState(false)
const[rowdata,setRowdata]=useState({})
const [selectedPatientId, setSelectedPatientId] = useState(null); 
const [paymentMenuOpen, setPaymentMenuOpen] = useState(false); 
const [selectedRowId, setSelectedRowId] = useState(null);
const [printingId, setPrintingId] = useState(null);
    const homescreenprev = useSelector((state) => state.userPrivileges.homescreen);
const dropdownRef = useRef(null);

// Print Notes encounter form for one signed-in patient (uses the shared
// printnotes data layer; the checkin row only carries name/patientid/provider).
const handlePrintEncounter = async (e, item) => {
  e.stopPropagation();
  setPrintingId(item.patientid);
  try {
    await printEncounterForPatient({
      patientid: item.patientid,
      name: fmtName(item.lastname, item.firstname),
      provider: item.linked_provider
        ? item.linked_provider.split('/').map((p) => p.trim()).join(', ')
        : '',
      time: fmtTime(item.starttime),
      date: item.startdate ? item.startdate.split('T')[0] : '',
    });
    // Persist who printed + when. The server reads the username from the JWT
    // and stores it in the appointment's signintime JSON (no schema change).
    try {
      const res = await api.put(
        `/v1/${practiseid}/checkin/patient/${item.patientid}/mark-printed`,
        {
          appointment_id: item.appointmentid,
          appointment_date: item.startdate ? item.startdate.split('T')[0] : '',
        }
      );
      if (res && res.printedBy) {
        setData((prev) =>
          prev.map((row) =>
            row.appointmentid === item.appointmentid
              ? {
                  ...row,
                  signintime: {
                    ...(row.signintime || {}),
                    printedBy: res.printedBy,
                    printedAt: res.printedAt,
                    printCount: res.printCount,
                  },
                }
              : row
          )
        );
      }
    } catch (markErr) {
      console.error('mark-printed failed', markErr);
    }
  } catch (err) {
    console.error('print encounter failed', err);
  } finally {
    setPrintingId(null);
  }
};
const HandleStatusfilterclose=()=>{
  SetIsStatusFilterPopup(false)
}
const practiseid = window.getPracticeId();

const handleProviderFilter=()=>{
  setIsProviderFilter(false)
}

const updateRow = async (obj) => {
  try { 
    const response = await api.put(`/v1/${practiseid}/checkin/patient/${rowdata?.patientid}/update-data`, {
      "appointment_id": rowdata?.appointmentid,
      "appointment_date": rowdata?.startdate?.split('T')[0] || '', // Fix the split logic
      ...obj
    });
 // ✅ update UI instantly (NO API reload)
    setData((prev) =>
      prev.map((row) =>
        row.appointmentid === rowdata.appointmentid
          ? { ...row, ...obj }
          : row
      )
    );

    setRowdata({
      ...rowdata, // Keep previous state values
      ...obj // Update with new values
    });
  } catch (error) {
    console.error("Error updating row:", error); // Log any errors
  } finally {
    setIsprovidersPopup(false)
    setIsStatusPopup(false)
   fetchdata({load:false})
    // Optionally do something here
  }
}

const getproviders = (providers) => {
  console.log('Providers received:', providers); // Debug log

  updateRow({
    'linked_provider': providers
  });
}
const updateStatus=(a)=>{
  updateRow({
    "visit_confirmation":String(a)
  });
}

const updateRoom=(a)=>{
  updateRow({
    "room_no": a ,
     "visit_confirmation": "Ready for Provider"
  });
}

useEffect(() => {
  console.log('Rowdata updated:', rowdata);
  // Any additional logic when rowdata changes can go here.
}, [rowdata]);

// const navigate = useNavigate(); 

// const handlePatientClick = (patientid) => {
//   navigate(`/landing?patientid=${patientid}`); 
// };
const ClosePaymentModal=()=>{
  setpaymentModal(false)
  setSelectedPatientId(null);
  setPaymentMenuOpen(false)
}

const navigate = useNavigate(); // Initialize the navigate function

// Function to handle patient click and navigate
const handlePatientClick = (item) => {
  navigate('/landing', { state: { item } }); // Pass the entire item as state
};

const openPaymentModal = (item) => {
  setpaymentModal(true); // Open the payment modal
  setSelectedPatientId(item);
  setSelectedRowId(null)
};

useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSelectedRowId(null); // Close dropdown if clicked outside
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);



  return (<>
    <div 
  style={{ boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.10)" ,borderRadius:'10px'}}
  className="inline-flex  md:w-full w-full  justify-center items-center  bg-[#FAFAF9]  mr-2 "
>

  <div className="w-full cursor-pointer  ">
  <div style={{ borderRadius: '10px', overflow: 'hidden' }}>
    <table className="min-w-full bg-[#FAFAF9] text-center" style={{ borderCollapse: 'separate', borderSpacing: '0' }}>
      <thead className="sticky top-0 bg-[#50869A] text-white">
        <tr>
          <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Token</th>
          <th onClick={()=>setIsProviderFilter(true)} className="py-3 px-4 border-b border-gray-200 text-[white]  font-inter text-[14px]">Provider</th>
          <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Location</th>
         {true&& <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">AppointmentTime</th>}
                 <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Check in Time</th>
          <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Patient</th>
  
          <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Room</th>
          <th onClick={()=>SetIsStatusFilterPopup(true)} className="py-3 px-4 border-b border-gray-200 text-[white] font-inter  text-[14px]">
            <div className='mr-20'>Status</div></th>
          <th className="py-3 px-4 border-b border-gray-200 text-[white] font-inter text-[14px]">Print</th>
        </tr>
      </thead>
      <tbody className='overflow-y-auto'>
        {/* When loading */}
        {loading ? (
          <tr>
            <td colSpan="6" className="py-2 px-4 text-center text-gray-500">
              Loading...
            </td>
          </tr>
        ) : data.length === 0 ? (
          // When there's no data
          <tr>
            <td colSpan="6" className="py-2 px-4 text-center text-gray-500">
             No Records Found
            </td>
          </tr>
        ) : (
          
      data
  .sort((a, b) => {
    const aTriage = a.visit_confirmation === "Ready for Triage";
    const bTriage = b.visit_confirmation === "Ready for Triage";

    // push triage to bottom
    if (aTriage && !bTriage) return 1;
    if (!aTriage && bTriage) return -1;

    // otherwise sort by token
    const tokenA = a.token || Number.MAX_SAFE_INTEGER;
    const tokenB = b.token || Number.MAX_SAFE_INTEGER;

    return tokenA - tokenB;
  })
          .map((item, index) => (
           <tr
  key={index}
  className={
    [
      "Walk-in",
      "Speak with Nurse",
      "Labs/Injections",
      "Speak with Representative"
    ].includes(item.visit_confirmation)
      ? "bg-[#fcefe0]"   // highlight color (light orange)
      : ""
  }
>

<td className="py-2 px-4 border-b border-gray-200 text-[#09090B] font-semibold text-[11px] font-Font1">
  <span  className='p-1 w-7 h-7 border-2 border-[#ccc]  rounded-full flex items-center justify-center ml-4'  style={{
    border: `2px solid ${item.deductiblemet ? `#${item.deductiblemet}` : '#ccc'}` // Default to gray if empty
  }}>
    {item.token || '-'}
  </span>
</td>
              <td className="py-2 px-4 border-b border-gray-200">
                <div className="w-full  flex flex-row flex-wrap gap-2  justify-center">
                {item.linked_provider
    ? item.linked_provider.split('/').map((provider, index) => (
        <button
          key={index}
          onClick={() => {
            
  setRowdata(item)
            setProvidersData(item.linked_provider.split('/').map(p => p.trim()));
            setIsprovidersPopup(true)

                
          
          }}
          className="rounded-full py-1 px-2 text-[12px] font-inter  text-[#E17954] border-[1.5px] border-[#E17954]"
        >
          {provider.trim()}
        </button>
      ))
    : null}
                </div>
              </td>
              <td className="py-2 px-4 border-b  text-[13px] border-gray-200">
{item?.signintime?.checkinFrom||'-'}
             </td>
            {true && <td className="py-3 px-4 font-inter  text-[13px]  border-b border-gray-200"> {(() => {
      const [hours, minutes] = item.starttime.split(":").slice(0, 2);
      let hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      if (hour > 12) hour -= 12; // Convert 24-hour format to 12-hour format
      if (hour === 0) hour = 12; // Handle midnight (00:xx becomes 12:xx AM)
      return `${hour}:${minutes} ${ampm}`;
    })()}</td>} 
             
              <td className="py-2 px-4 border-b  text-[13px] border-gray-200">
  {item.signintime && item.signintime.ReadyForTriageTime 
    ? dayjs(item.signintime.ReadyForTriageTime).format('hh:mm A') 
    : '-'}
</td>
 <td className="py-2 px-4 border-b border-gray-200">
                <div >
              <div>
  <div
    onClick={() => handlePatientClick(item)}
    className="font-inter text-[12.8px] font-normal text-center hover:underline flex items-center justify-center gap-1 flex-wrap"
  >
    <span>{`${item.firstname} ${item.lastname}`}</span>
    {item.ordertype === "Labs" && (
      <img className="w-[20px] h-[20px]" src={labsIcon} alt="Labs Icon" />
    )}
  </div>

  <div className="text-[#B1B1B1] flex justify-center text-[12px] font-inter text-center">
    {item.patientid}
  </div>
</div>

             
                </div>
              </td>
              <td className="py-2 px-4 border-b border-gray-200">
              <div className="flex justify-center">
  {item.room_no && item.room_no !== "0" ? (
    item.room_no === "Waiting Room" ? (
      <div
      onClick={()=>{
            
        setRowdata(item)
        setRoomPopUp(true)}}
      className="text-[#50869A] text-[13px] font-inter font-medium">Waiting Room</div>
    ) : (
      <div 
   onClick={()=>{
           
        setRowdata(item)
        setRoomPopUp(true)}}
      className="w-8 h-8 bg-[#E17954B2] p-[12px] font-inter text-white rounded-full flex items-center justify-center text-[12px]">
        {item.room_no.slice(0,3)}
      </div>
    )
  ) : (
    <div
  onClick={()=>{
            
        setRowdata(item)
        setRoomPopUp(true)}}
    className="text-[#B1B1B1] text-[14px]"> <span  className="w-8 h-8 bg-[#E17954B2] p-[12px] text-white rounded-full flex items-center justify-center text-[12px]">-</span></div>
  )}
         </div>

              </td>
              <td className="flex py-2 px-4 border-b border-gray-200  ">
              {item.visit_confirmation ? (
  <button
    onClick={() => {

      
  setRowdata(item);
      setIsStatusPopup(true)
             
     ;
    }}
    className={`rounded-full py-2 px-4 text-[12px] border-[1.5px] border-gray-100 font-inter w-[160px] ${
      item.visit_confirmation === "Ready for Triage"
        ? "bg-[#F0FDF4] text-[#50869A]"
        : item.visit_confirmation === "Checked Out"
        ? "bg-[#E1795459] text-[#C2410C]"
        : item.visit_confirmation === "Processing"
        ? "bg-[#DBEAFE] text-[#1D4ED8]"
        : item.visit_confirmation === "Ready for Checkout"
        ? "bg-[#DBEAFE] text-[#1D4ED8]"
        : item.visit_confirmation === "Ready for Provider"
        ? "bg-[#F3E8FF] text-[#9333EA]"
        : "bg-[#ECECEE] text-[#1D4ED8]" // default
    }`}

    style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
  >
    {item.visit_confirmation || '-'}
  </button>
) : (
  <button
  onClick={() => {
  
    setRowdata(item);
    setIsStatusPopup(true);
    
  }}
  className={`rounded-full py-2 px-4 text-[12px] border-[1.5px] border-gray-100 font-inter w-[160px] ${
    item.visit_confirmation === "Ready for Triage"
      ? "bg-[#F0FDF4] text-[#50869A]"
      : item.visit_confirmation === "Checked Out"
      ? "bg-[#E1795459] text-[#C2410C]"
      : item.visit_confirmation === "Processing"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.visit_confirmation === "Ready for Checkout"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : item.visit_confirmation === "Ready for Provider"
      ? "bg-[#DBEAFE] text-[#1D4ED8]"
      : "bg-[#ECECEE] text-[#1D4ED8]" // default
  }`}

  style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
>
  {item.visit_confirmation || '-'}
</button>
       )}
           
                      
           {homescreenprev.includes('Take Payment')&&<DropdownMenu
            item={item}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
            openPaymentModal={openPaymentModal}
          />}

             </td>
             <td className="py-2 px-2 border-b border-gray-200 align-middle">
               <div className="flex items-center justify-center gap-1.5">
                 <button
                   onClick={(e) => handlePrintEncounter(e, item)}
                   disabled={printingId === item.patientid}
                   className={`rounded-full py-1 px-3 text-[12px] font-inter border-[1.5px] disabled:opacity-50 ${
                     item.signintime?.printedBy
                       ? 'border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white'
                       : 'border-[#50869A] text-[#50869A] hover:bg-[#50869A] hover:text-white'
                   }`}
                 >
                   {printingId === item.patientid
                     ? 'Printing…'
                     : item.signintime?.printedBy
                     ? 'Reprint'
                     : 'Print'}
                 </button>
                 {item.signintime?.printedBy && (
                   <span
                     title={`Printed by ${item.signintime.printedBy}${item.signintime.printedAt ? ' · ' + dayjs(item.signintime.printedAt).format('M/D h:mm A') : ''}`}
                     className="flex items-center justify-center w-[15px] h-[15px] shrink-0 rounded-full border border-[#16A34A] text-[#16A34A] text-[10px] font-bold leading-none cursor-help"
                   >
                     i
                   </span>
                 )}
               </div>
             </td>

            </tr>
          ))
        )}
      </tbody>
    </table>
    </div>
  </div>
</div>
    
  <StatusFilterPopup
  isOpen={isstatusFilterpopup}
  onClose={HandleStatusfilterclose}
  onStatusSelect={onStatusSelect} 
  statusdata={statusdata}
  />
  <ProviderFilterPopup
  isOpen={isProviderfilter}
  onClose={handleProviderFilter}
  onProviderSelect={onProviderSelect}
  providerData={statusdata}
  />
    <ProvidersPopup 
    getproviders={getproviders}
    doctorNames={providersdata}
    isOpen={isProvidersPopup} 
    onClose={()=>setIsprovidersPopup(false)}/>
        <StatusPopup
        
        updateStatus={updateStatus}
        isOpen={isStatusPopup} 
        onClose={()=>setIsStatusPopup(false)}/>
   
<RoomPopup
    updateRoom={updateRoom}
    isOpen={roomPopUp} 
    onClose={()=>setRoomPopUp(false)}
    rowdata={rowdata}
    fetchdata={fetchdata}
    data={data}
/>
 {paymentModal?<Payments data={selectedPatientId} alldata={data} fetchdata={fetchdata} isOpen={paymentModal}   ClosePaymentModal={ClosePaymentModal}/>:<></>}

          
    </>
  );
};

export default SigninTable;
